import React, { FC } from 'react';

import { Checkbox, CheckboxProps } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import css from './styles.css';

export type SummarizationMailRecipientCheckboxProps = Pick<CheckboxProps, 'isSelected' | 'isDisabled' | 'onChange'>;

export const SummarizationMailRecipientCheckbox: FC<SummarizationMailRecipientCheckboxProps> = (props) => {
    return (
        <Checkbox
            {...props}
            className={css.checkbox}
            label={i18n('summarization', 'send-summary-to-participants')}
            size="lg"
        />
    );
};
